"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.impossibleVehicleSchema = exports.vehicleYearString = exports.vehiclePurchaseDateString = exports.MAX_VEHICLE_AGE = exports.MIN_VEHICLE_AGE = exports.MIN_VEHICLE_PURCHASE_YEARS = void 0;
const zod_1 = require("zod");
const Address_1 = require("./Address");
const PersonalAutoDiscount_1 = require("./PersonalAutoDiscount");
const VehicleOwnershipStatusTypes_1 = require("../enums/VehicleOwnershipStatusTypes");
const VehicleUseTypes_1 = require("../enums/VehicleUseTypes");
const constants_1 = require("../constants");
const VehicleType_1 = require("../enums/VehicleType");
const numbers_1 = require("../numbers");
const PersonalAutoCoverage_1 = require("./PersonalAutoCoverage");
const dates_1 = require("../dates");
const Name_1 = require("./Name");
exports.MIN_VEHICLE_PURCHASE_YEARS = 0;
exports.MIN_VEHICLE_AGE = -1;
exports.MAX_VEHICLE_AGE = 100;
exports.vehiclePurchaseDateString = zod_1.z
    .string()
    .regex(constants_1.REGEX.iso8601Date)
    .refine((0, dates_1.isDateStringInAgeRangeFactory)(exports.MIN_VEHICLE_PURCHASE_YEARS, exports.MAX_VEHICLE_AGE), {
    message: `Vehicle purchase date can not be newer than ${exports.MIN_VEHICLE_PURCHASE_YEARS} years or older than ${exports.MAX_VEHICLE_AGE} years`,
});
exports.vehicleYearString = zod_1.z.nullable(zod_1.z.string().refine((year) => {
    const currentYear = new Date().getFullYear();
    const currentDateFunction = () => Date.parse(`${currentYear}`);
    const vehicleAge = (0, dates_1._getYearsToNowFP)(year, currentDateFunction, Date.parse);
    const isInAgeRange = (0, dates_1.isAgeInRangeFactory)(exports.MIN_VEHICLE_AGE, exports.MAX_VEHICLE_AGE);
    return isInAgeRange(Math.round(vehicleAge));
}, {
    message: `Vehicle year should be beetween ${exports.MAX_VEHICLE_AGE} years ago to ${Math.abs(exports.MIN_VEHICLE_AGE)} year in the future from present`,
}));
exports.impossibleVehicleSchema = zod_1.z.object({
    year: exports.vehicleYearString.optional(),
    inStorage: zod_1.z.nullable(zod_1.z.boolean()).optional(),
    isRideSharing: zod_1.z.nullable(zod_1.z.boolean()).optional(),
    vin: zod_1.z.nullable(zod_1.z.string().min(5).max(17).regex(constants_1.REGEX.digitsAndLettersOnly)).optional(),
    make: zod_1.z.nullable(zod_1.z.string().min(2).max(339).regex(constants_1.REGEX.defaultString)).optional(),
    model: zod_1.z.nullable(zod_1.z.string().min(1).max(100).regex(constants_1.REGEX.defaultString)).optional(),
    type: zod_1.z.nullable(zod_1.z.nativeEnum(VehicleType_1.VehicleType)).optional(),
    annualMileage: zod_1.z.nullable(zod_1.z.number().min(0).max((0, numbers_1.thousand)(801))).optional(),
    driver: zod_1.z.nullable(Name_1.impossibleNameSchema).optional(),
    use: zod_1.z.nullable(zod_1.z.nativeEnum(VehicleUseTypes_1.VehicleUseTypes)).optional(),
    garagingLocationRaw: zod_1.z.nullable(zod_1.z.string().min(constants_1.MIN_DEFAULT_STRING_LENGTH).max(128).regex(constants_1.REGEX.defaultString)).optional(),
    garagingLocation: zod_1.z.nullable(Address_1.impossibleAddressSchema).optional(),
    discounts: zod_1.z.nullable(zod_1.z.array(PersonalAutoDiscount_1.impossiblePersonalAutoDiscountSchema)).optional(),
    discountTotalCents: zod_1.z.nullable(zod_1.z.number().min(0).max((0, numbers_1.thousand)(500))).optional(),
    purchaseDate: zod_1.z.nullable(exports.vehiclePurchaseDateString).optional(),
    antiTheftDevices: zod_1.z.nullable(zod_1.z.boolean()).optional(),
    bodyStyle: constants_1.defaultOptionalString,
    ownershipStatus: zod_1.z.nullable(zod_1.z.nativeEnum(VehicleOwnershipStatusTypes_1.VehicleOwnershipStatusTypes)).optional(),
    lienHolder: zod_1.z.nullable(zod_1.z.string().min(2).max(constants_1.MAX_DEFAULT_STRING_LENGTH).regex(constants_1.REGEX.defaultString)).optional(),
    lienHolderAddress: zod_1.z.nullable(Address_1.impossibleAddressSchema).optional(),
    lienHolderAddressRaw: zod_1.z.nullable(zod_1.z.string().min(5).max(128).regex(constants_1.REGEX.defaultString)).optional(),
    premiumCents: zod_1.z.nullable(zod_1.z.number().min(1).max((0, numbers_1.million)(5))).optional(),
    coverages: zod_1.z.optional(zod_1.z.array(PersonalAutoCoverage_1.impossiblePersonalAutoCoverageSchema).min(1).max(20)),
}).strict();
